<script setup lang="ts">
import SingleCourse from "~/components/Redmonkey/Courses/Single.vue";

const pageStore = usePageStore();

const props = defineProps({
  element: {
    type: Object,
    required: true
  }
});

const courseData = ref({});

const {data: coursesData} = await useFetch('/api/wordpress/getCourses', {
  method: 'post',
  body: {
    first: 1,
    ids: [props.element?.post_id || pageStore?.routeData?.id]
  }
})

const {courses} = coursesData.value;

courseData.value = {
  ...(courses?.nodes?.[0] || {}),
  settings: (props.element?.settings || {}),
  pageInfo: (courses?.pageInfo || {})
}

</script>
<template>
  <SingleCourse :course="courseData"/>
</template>

<style lang="scss">
  @import "assets/css/source/components/widgets/faq";
  @import "assets/css/source/components/widgets/courses";
  @import "assets/css/source/components/widgets/single_course";
</style>